export class Sfx {
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;
  muted = false;

  ensure(): AudioContext {
    if (!this.ctx) {
      const ctx = new AudioContext();
      this.master = ctx.createGain();
      this.master.gain.value = 0.22;
      this.master.connect(ctx.destination);
      this.ctx = ctx;
    }
    return this.ctx;
  }

  private out(): GainNode {
    this.ensure();
    return this.master!;
  }

  blip(freq: number, dur: number, type: OscillatorType, vol = 0.4, slide = 0): void {
    if (this.muted) return;
    const ctx = this.ensure();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.value = freq;
    if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, freq + slide), ctx.currentTime + dur);
    g.gain.value = vol;
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + dur);
    o.connect(g);
    g.connect(this.out());
    o.start();
    o.stop(ctx.currentTime + dur + 0.02);
  }

  noise(dur: number, vol = 0.2, freq = 800): void {
    if (this.muted) return;
    const ctx = this.ensure();
    const n = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate);
    const d = n.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    const src = ctx.createBufferSource();
    src.buffer = n;
    const f = ctx.createBiquadFilter();
    f.type = "lowpass";
    f.frequency.value = freq;
    const g = ctx.createGain();
    g.gain.value = vol;
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + dur);
    src.connect(f);
    f.connect(g);
    g.connect(this.out());
    src.start();
  }

  place(): void {
    this.noise(0.06, 0.18, 1400);
    this.blip(220, 0.05, "triangle", 0.12);
  }

  break(): void {
    this.noise(0.1, 0.25, 700);
    this.blip(140, 0.08, "square", 0.08, -80);
  }

  ui(): void {
    this.blip(520, 0.04, "sine", 0.1);
  }

  hurt(): void {
    this.blip(180, 0.12, "sawtooth", 0.16, -100);
  }

  splash(): void {
    this.noise(0.16, 0.2, 900);
  }

  step(): void {
    this.noise(0.04, 0.08, 500);
  }
}
